import axios from 'axios';
import config from '@/config/env-constants';

export default {

  newCompany(companyId, currUserId) {
    const url = `${config.cloudFunctionsBaseUrl}/newCompany`;
    return axios.post(url, { companyId, currUserId });
  }

}